import { render, staticRenderFns } from "./ExamContentView.vue?vue&type=template&id=253274d6&scoped=true&"
import script from "./ExamContentView.vue?vue&type=script&lang=js&"
export * from "./ExamContentView.vue?vue&type=script&lang=js&"
import style0 from "./ExamContentView.vue?vue&type=style&index=0&id=253274d6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253274d6",
  null
  
)

export default component.exports